<template>
  <div class="dialog-wrap">
    <el-dialog title="新建推广商品"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="520px">
      <el-form ref="dataForm"
               :model="dataForm"
               :rules="rules"
               label-width="100px">
        <el-form-item label="推广类型" prop="foster_type">
          <el-select v-model="dataForm.foster_type" placeholder="请选择" @change="handleFosterTypeChange">
            <el-option label="渠道分销" :value="1"></el-option>
            <el-option label="分享推广" :value="2"></el-option>
            <el-option label="主理人合作" :value="3"></el-option>
            <el-option label="机构合作" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="isSupportedType">
          <el-form-item label="商品类型">
            <el-select v-model="productType" @change="handleProductTypeChange">
              <el-option label="课程" :value="1"></el-option>
              <el-option label="题库" :value="2"></el-option>
              <el-option label="专栏" :value="3"></el-option>
              <el-option label="资料" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择商品" prop="product_name">
            <el-input :value="dataForm.product_name"
                      placeholder="选择商品"
                      suffix-icon="el-icon-search"
                      readonly
                      @focus="handleGoodChoose"></el-input>
          </el-form-item>
          <el-form-item label="产品提供方" prop="provider_type">
            <el-select v-model="dataForm.provider_type" placeholder="请选择产品提供方">
              <el-option label="平台" :value="1"></el-option>
              <el-option label="学长" :value="2"></el-option>
              <el-option label="主理人" :value="3"></el-option>
              <el-option label="合作机构" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dataForm.foster_type === 1"
                        label="服务对象"
                        prop="service_user_type">
            <el-select v-model="dataForm.service_user_type" placeholder="请选择">
              <el-option label="学员" :value="1"></el-option>
              <el-option label="加盟商" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dataForm.foster_type === 1" label="采购折扣" prop="sale_percent">
            <el-input v-model="dataForm.sale_percent" placeholder="请输入采购折扣">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="dataForm.foster_type === 2" label="分佣比例" prop="recommend_fee_percent">
            <el-input v-model="dataForm.recommend_fee_percent" placeholder="请输入分佣比例">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="dataForm.foster_type === 4" label="平台分成" prop="platform_fee_percent">
            <el-input v-model="dataForm.platform_fee_percent" placeholder="请输入整数百分比（0-100）">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="dataForm.foster_type === 1" label="起订份数" prop="base_order_count">
            <el-input v-model="dataForm.base_order_count" type="number" placeholder="请输入起订份数">
              <template slot="append">份</template>
            </el-input>
          </el-form-item>
          <el-form-item label="分类名称">
            <el-select v-model="dataForm.categories"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="输入分类后按回车添加"
                       style="width: 100%">
            </el-select>
          </el-form-item>
          <el-form-item :label="institutionLabel" prop="institutions">
            <div class="tag-wrap">
              <el-tag v-for="item in dataForm.institutions"
                      :key="item.id"
                      class="subject-item"
                      closable
                      @close="handleInstitutionRemove(item)">{{ item.name }}</el-tag>
            <el-button type="text" @click="handleInstitutionChoose">选择机构</el-button>
            <div v-if="institutionLimit" class="field-tip">{{ institutionLimit === 1 ? '请选择1个机构' : '请选择1至10个机构' }}</div>
            </div>
          </el-form-item>
          <el-form-item label="排序值" prop="sort">
            <el-input v-model="dataForm.sort" placeholder="请输入排序值"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :disabled="!isSupportedType" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <ContentChoose :visible="goodChooseDialog"
                   :ref_type="productType"
                   @close="goodChooseDialog = false"
                   @submit="saveGood"></ContentChoose>
    <InstitutionChoose :visible="institutionChooseDialog"
                       :colleges="dataForm.institutions"
                       :max-selection="institutionLimit"
                       @close="institutionChooseDialog = false"
                       @submit="saveInstitution"></InstitutionChoose>
  </div>
</template>

<script>
import ContentChoose from '@/components/dialog/ContentChoose'
import InstitutionChoose from '@/components/dialog/warrant/InstitutionChoose'
import { createWarrantProduct } from '@/api/warrant'

const percentageRule = (rule, value, callback) => {
  const number = Number(value)
  if (value === '' || value === null || value === undefined || Number.isNaN(number) || number < 0 || number > 100) {
    callback(new Error('比例范围为0-100'))
    return
  }
  callback()
}

const platformPercentageRule = (rule, value, callback) => {
  const number = Number(value)
  if (value === null || value === undefined || String(value).trim() === '' || !Number.isInteger(number) || number < 0 || number > 100) {
    callback(new Error('平台分成请输入0-100的整数百分比'))
    return
  }
  callback()
}

export default {
  components: { ContentChoose, InstitutionChoose },
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      dialogVisible: this.visible,
      productType: 1,
      goodChooseDialog: false,
      institutionChooseDialog: false,
      dataForm: this.getInitialForm(),
      rules: {
        foster_type: [{ required: true, message: '请选择推广类型', trigger: 'change' }],
        product_name: [{ required: true, message: '请选择商品', trigger: 'change' }],
        service_user_type: [{ required: true, message: '请选择服务对象', trigger: 'change' }],
        sale_percent: [{ required: true, validator: percentageRule, trigger: 'blur' }],
        recommend_fee_percent: [{ required: true, validator: percentageRule, trigger: 'blur' }],
        platform_fee_percent: [{ required: true, validator: platformPercentageRule, trigger: 'blur' }],
        institutions: [{ validator: this.validateInstitutions, trigger: 'change' }],
        base_order_count: [{ required: true, message: '请输入起订份数', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序值', trigger: 'blur' }],
      },
    }
  },
  computed: {
    isSupportedType() {
      return [1, 2, 3, 4].includes(this.dataForm.foster_type)
    },
    institutionLimit() {
      return this.dataForm.foster_type === 3 ? 10 : this.dataForm.foster_type === 4 ? 1 : 0
    },
    institutionLabel() {
      return this.dataForm.foster_type === 3 ? '主理机构' : this.dataForm.foster_type === 4 ? '合作机构' : '专属机构'
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
      if (!value) this.resetForm()
    },
  },
  methods: {
    getInitialForm() {
      return {
        foster_type: '',
        product_id: '',
        product_name: '',
        service_user_type: '',
        sale_percent: '',
        recommend_fee_percent: '',
        platform_fee_percent: '',
        provider_type: '',
        base_order_count: 1,
        categories: [],
        institutions: [],
        sort: '',
      }
    },
    handleProductTypeChange() {
      this.dataForm.product_id = ''
      this.dataForm.product_name = ''
    },
    handleFosterTypeChange() {
      this.dataForm.service_user_type = ''
      this.dataForm.sale_percent = ''
      this.dataForm.recommend_fee_percent = ''
      this.dataForm.platform_fee_percent = ''
      this.dataForm.base_order_count = 1
      this.dataForm.institutions = []
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    validateInstitutions(rule, value, callback) {
      const count = Array.isArray(value) ? value.length : 0
      if ((this.dataForm.foster_type === 3 || this.dataForm.foster_type === 4) && count === 0) {
        callback(new Error('请选择关联机构'))
      } else if (this.institutionLimit && count > this.institutionLimit) {
        callback(new Error(`最多选择${this.institutionLimit}个机构`))
      } else {
        callback()
      }
    },
    handleGoodChoose() {
      this.goodChooseDialog = true
    },
    saveGood(product) {
      this.dataForm.product_id = product.id
      this.dataForm.product_name = product.name
      this.goodChooseDialog = false
    },
    handleInstitutionChoose() {
      this.institutionChooseDialog = true
    },
    saveInstitution({ colleges }) {
      this.dataForm.institutions = [...colleges]
      this.institutionChooseDialog = false
      this.$refs.dataForm.validateField('institutions')
    },
    handleInstitutionRemove(item) {
      this.dataForm.institutions = this.dataForm.institutions.filter((value) => value.id !== item.id)
      this.$refs.dataForm.validateField('institutions')
    },
    normalizedCategories() {
      return [...new Set(this.dataForm.categories.map((value) => String(value).trim()).filter(Boolean))]
    },
    buildParams() {
      const params = {
        foster_type: this.dataForm.foster_type,
        product_id: this.dataForm.product_id,
        product_type: this.productType,
        arr_category_name: this.normalizedCategories(),
        arr_ref_cid: this.dataForm.institutions.map((item) => item.cid || item.id),
        sort: this.dataForm.sort,
        status: 1,
      }
      if (this.dataForm.provider_type !== '') params.provider_type = this.dataForm.provider_type
      if (this.dataForm.foster_type === 1) {
        params.service_user_type = this.dataForm.service_user_type
        params.sale_percent = Number(this.dataForm.sale_percent)
        params.base_order_count = Number(this.dataForm.base_order_count)
      } else if (this.dataForm.foster_type === 2) {
        params.service_user_type = 1
        params.recommend_fee_percent = Number(this.dataForm.recommend_fee_percent) / 100
      } else if (this.dataForm.foster_type === 4) {
        params.platform_fee_percent = Number(this.dataForm.platform_fee_percent) / 100
      }
      return params
    },
    handleSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid || !this.isSupportedType || !this.dataForm.product_id) {
          if (!this.dataForm.product_id) this.$message.error('请选择商品')
          return
        }
        createWarrantProduct(this.buildParams()).then(() => {
          this.$message.success('创建成功')
          this.$emit('submit')
          this.handleClose()
        })
      })
    },
    resetForm() {
      this.dataForm = this.getInitialForm()
      this.productType = 1
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.tag-wrap { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.subject-item { margin: 0; }
.field-tip { color: #909399; font-size: 12px; line-height: 20px; }
</style>
